/* eslint-disable react/react-in-jsx-scope */
import { useContext } from 'react';
// import { useTranslation } from 'react-i18next';
import Brand from '../../../layout/Brand/Brand';
import Navigation, { NavigationLine } from '../../../layout/Navigation/Navigation';
import User from '../../../layout/User/User';
import { allowancesMenu, masterPagesMenu, reportsMenu, superAdminMenu, stationaryMenu } from '../../../menu';
import ThemeContext from '../../../contexts/themeContext';
// import useDarkMode from '../../../hooks/useDarkMode';
import Aside, { AsideBody, AsideFoot, AsideHead } from '../../../layout/Aside/Aside';
import { useSelector } from 'react-redux';
import { selectLoginResponse } from '../../../redux/login/login.selector';

const DefaultAside = () => {
	const { asideStatus, setAsideStatus } = useContext(ThemeContext);

	// const { t } = useTranslation(['translation', 'menu']);

	// const { darkModeStatus } = useDarkMode();
	const loginData = useSelector(selectLoginResponse);
	const role = loginData?.data?.role || loginData?.role;
	if (process.env.NODE_ENV === 'development') console.log('Role ', role);
	return (
		<Aside>
			<AsideHead>
				<Brand asideStatus={asideStatus} setAsideStatus={setAsideStatus} />
			</AsideHead>
			<AsideBody>
				{role === 'Admin' && (
					<>
						<Navigation menu={masterPagesMenu} id='aside-master-pages' />
						<NavigationLine />
						<Navigation menu={reportsMenu} id='aside-reports' />
						<NavigationLine />
						<Navigation menu={allowancesMenu} id='aside-allowances' />
						<NavigationLine />
						<Navigation menu={stationaryMenu} id='aside-stationary' />
					</>
				)}
				{role === 'SuperAdmin' && (
					<>
						<Navigation menu={masterPagesMenu} id='aside-master-pages' />
						<NavigationLine />
						<Navigation menu={superAdminMenu} id='aside-super-pages' />
						<NavigationLine />
						<Navigation menu={reportsMenu} id='aside-reports' />
						<NavigationLine />
						<Navigation menu={allowancesMenu} id='aside-allowances' />
						<NavigationLine />
						<Navigation menu={stationaryMenu} id='aside-stationary' />
					</>
				)}
				{role === 'AllowancesAdmin' && (
					<>
						<Navigation menu={allowancesMenu} id='aside-allowances' />
						<NavigationLine />
					</>
				)}
				{role === 'HR' && (
					<>
						<Navigation menu={reportsMenu} id='aside-reports' />
						<NavigationLine />
					</>
				)}
			</AsideBody>
			<AsideFoot>
				<User />
			</AsideFoot>
		</Aside>
	);
};

export default DefaultAside;
